module.exports = __webpack_public_path__ + "media/images/common/defaults/empty-ed34623b1b6a87adc9278404e6409547.png";